export function getRole() {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return user.role || 'MEMBER';
}

export const isAdmin = () => getRole() === 'ADMIN';
export const isManager = () => ['ADMIN', 'PM', 'TEAM_LEAD'].includes(getRole());
export const isDeveloper = () => ['ADMIN', 'PM', 'TEAM_LEAD', 'DEVELOPER'].includes(getRole());
export const isMember = () => true;
